/** Shared business-type labels and catalog badge styles. */
export const BUSINESS_TYPES = [
  {
    id: 'company',
    label: 'شرکت',
    badgeClass: 'border-signal/30 bg-signal/[0.06] text-signal',
    selectedBorder: 'border-signal',
    selectedBg: 'bg-sky-wash',
  },
  {
    id: 'factory',
    label: 'کارخونه',
    badgeClass: 'border-amber-tag/35 bg-amber-tag/[0.09] text-amber-tag',
    selectedBorder: 'border-amber-tag',
    selectedBg: 'bg-amber-tag/[0.06]',
  },
  {
    id: 'workshop',
    label: 'کارگاه',
    badgeClass: 'border-emerald-status/35 bg-emerald-status/[0.09] text-emerald-status',
    selectedBorder: 'border-emerald-status',
    selectedBg: 'bg-emerald-status/[0.06]',
  },
  {
    id: 'production',
    label: 'تولیدی',
    badgeClass: 'border-coral-alert/35 bg-coral-alert/[0.09] text-coral-alert',
    selectedBorder: 'border-coral-alert',
    selectedBg: 'bg-coral-alert/[0.06]',
  },
];

export const VALID_BUSINESS_TYPE_IDS = BUSINESS_TYPES.map((t) => t.id);

export function isValidBusinessType(type) {
  if (!type) return false;
  return VALID_BUSINESS_TYPE_IDS.includes(String(type).toLowerCase());
}

export function getBusinessType(type) {
  if (!type) return null;
  return BUSINESS_TYPES.find((t) => t.id === String(type).toLowerCase()) ?? null;
}

export function getBusinessTypeLabel(type) {
  return getBusinessType(type)?.label ?? null;
}

export function getBusinessTypeBadgeClass(type) {
  return getBusinessType(type)?.badgeClass ?? 'border-hairline/35 bg-sky-wash/60 text-steel';
}

export const BUSINESS_TYPE_I18N_KEYS = {
  company: 'businessDashboard.companyTag',
  factory: 'businessDashboard.factoryTag',
  workshop: 'businessDashboard.workshopTag',
  production: 'businessDashboard.productionTag',
};

export function isWorkshopOrProduction(type) {
  return type === 'workshop' || type === 'production';
}

export function isCompanyType(type) {
  return type === 'company';
}

export function isFactoryType(type) {
  return type === 'factory';
}

/** فیلدهای اختصاصی هر نوع کسب‌وکار در فرم ثبت‌نام */
export function getRegistrationFieldVisibility(businessType) {
  const type = businessType || '';
  const isCompany = isCompanyType(type);
  const isFactory = isFactoryType(type);
  const isWorkshopProd = isWorkshopOrProduction(type);

  return {
    economicCode: isFactory,
    faxNumber: isFactory,
    address: !isCompany,
    companyAddress: isCompany,
    factoryAddress: isFactory,
    headOfficeAddress: isFactory,
    showExtendedFields: isFactory,
  };
}
